var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasFeature("FEATURE_ORDERBOXES") &&
    _vm.order.box &&
    _vm.order.status != "empty"
    ? _c(
        "div",
        {
          directives: [
            {
              name: "hammer",
              rawName: "v-hammer:tap",
              value: _vm.onClick,
              expression: "onClick",
              arg: "tap",
            },
            {
              name: "hammer",
              rawName: "v-hammer:press",
              value: _vm.onLongClick,
              expression: "onLongClick",
              arg: "press",
            },
          ],
          staticClass: "control__single",
        },
        [
          _c("div", { staticClass: "control__box" }, [
            _vm._v("box " + _vm._s(_vm.order.box)),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "control__number control__number--no-top-padding" },
            [_vm._v(_vm._s(_vm._f("fwgshortorder")(_vm.order.number)))]
          ),
          _vm._v(" "),
          _vm.order.pagernumber
            ? _c(
                "div",
                { staticClass: "control__badge control__badge--pager" },
                [_vm._v("p")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.order.trackernumber
            ? _c(
                "div",
                { staticClass: "control__badge control__badge--tracker" },
                [_vm._v("t")]
              )
            : _vm._e(),
        ]
      )
    : _vm.hasFeature("FEATURE_ORDERBOXES") && _vm.order.box
    ? _c(
        "div",
        {
          directives: [
            {
              name: "hammer",
              rawName: "v-hammer:tap",
              value: _vm.onClick,
              expression: "onClick",
              arg: "tap",
            },
            {
              name: "hammer",
              rawName: "v-hammer:press",
              value: _vm.onLongClick,
              expression: "onLongClick",
              arg: "press",
            },
          ],
          staticClass: "control__single",
        },
        [
          _c("div", { staticClass: "control__box control__box--empty" }, [
            _vm._v("box " + _vm._s(_vm.order.box)),
          ]),
        ]
      )
    : _c(
        "div",
        {
          directives: [
            {
              name: "hammer",
              rawName: "v-hammer:tap",
              value: _vm.onClick,
              expression: "onClick",
              arg: "tap",
            },
            {
              name: "hammer",
              rawName: "v-hammer:press",
              value: _vm.onLongClick,
              expression: "onLongClick",
              arg: "press",
            },
          ],
          key: _vm.order.id,
          staticClass: "control__single",
        },
        [
          _c("div", { staticClass: "control__number" }, [
            _vm._v(_vm._s(_vm._f("fwgshortorder")(_vm.order.number))),
          ]),
          _vm._v(" "),
          _vm.order.pagernumber
            ? _c(
                "div",
                { staticClass: "control__badge control__badge--pager" },
                [_vm._v("p")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.order.trackernumber
            ? _c(
                "div",
                { staticClass: "control__badge control__badge--tracker" },
                [_vm._v("t")]
              )
            : _vm._e(),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }